import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-deletion-modal',
  templateUrl: './deletion-modal.component.html',
  styleUrls: ['./deletion-modal.component.sass']
})
export class DeletionModalComponent {

  // eslint-disable-next-line no-empty-function
  constructor(public dialogRef: MatDialogRef<DeletionModalComponent>,@Inject(MAT_DIALOG_DATA) public text: any) { }

  submit(d) {
    this.dialogRef.close(d);
  }
}
